import { css, Interpolation, keyframes } from '@emotion/core';
import theme from 'static/themes/theme';
import { rgba } from 'polished';

const pulse = keyframes`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
`;

export const logo = css`
    animation: ${pulse} 3s ease infinite;
`;

export const wrapper: Interpolation = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 32
};

export const loading: Interpolation = {
    width: 80,
    height: 80,
    borderRadius: 8,
    backgroundColor: theme.colors.white
};

export const fixed: Interpolation = {
    position: 'fixed',
    zIndex: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: theme.colors.light,
    img: {
        maxWidth: 300
    }
};

export const spinner: Interpolation = {
    width: 48,
    height: 48,
    position: 'relative',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 16
};

export const inside: Interpolation = {
    '@keyframes spinner': {
        '0%': {
            transform: 'rotate(0deg)'
        },
        '100%': {
            transform: 'rotate(360deg)'
        }
    },
    boxSizing: 'border-box',
    display: 'block',
    position: 'absolute',
    width: 48,
    height: 48,
    border: `2px solid ${theme.colors.green}`,
    borderRadius: '50%',
    animation: 'spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
    borderColor: `${theme.colors.green} transparent transparent transparent`,
    top: 0,
    left: 0,

    '&:nth-child(1)': {
        animation: 'none',
        borderColor: rgba(theme.colors.green, 0.2)
    }
};
